import React, { createContext } from 'react'

export const RedisDataContext = createContext(null) 

const routes = [
  {
    component: "PageType-0",
    featureId: 1,
    isDebug: false,
    isEnabled: true,
    name: "Production Statistics",
    pageType: "PageType-0",
    pageTypeId:0,
    path: "/dashboard/product-statistics",
    layout: "/admin",
    submenu: false,
    title:"Production Statistics"
  },
];

export const routeConfig = routes;



